import { z } from 'zod';

export const invoiceServicePositionSchema = z.object({
    id: z.number().default(-1),
    Invoice: z.number(),
    InvoiceServicePositionType: z.number().default(10),
    Partner: z.number().nullable().default(null),
    Service: z.number().nullable().default(null),
    Unit: z.number().nullable().default(1),

    articelNumber: z.string().default(""),
    title: z.string().default(""),
    description: z.string().default(""),
    units: z.number().default(0),
    position: z.number().default(1),
    timeFactor: z.number().default(0),
    price_per_hour: z.number().default(0),
    price: z.number().default(0),

    wasChangedTimeFactor: z.boolean().default(false),
    wasChangedPricePerHour: z.boolean().default(false),
    wasChangedTitle: z.boolean().default(false),
    wasChangedPrice: z.boolean().default(false),
})



export type IInvoiceServicePosition = z.infer<typeof invoiceServicePositionSchema>;